export enum FontSize {
    S = '16px',
    M = '18px',
    L = "20px",
  }

export enum Colors {
    GRAY = '#e5e4e2',
    DARK_GRAY='#212529',
    WHITE= '#fff',
    GREEN='green',
    //DARK_BLUE='#00004d',
    DARK_BLUE= '#212529',
    GRAY_FOR_TITEL='gray',
    LIGHT_BLUE='#f2f6ff'
  }